module.exports = __webpack_public_path__ + "4a0d502fdca8a04779a9e56736b598df.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/fedex_2023_chart.png
// module id = 1676
// module chunks = 0